// services/api/settingsApi.js
import axiosInstance from "utils/axiosInstance";

const leaveApi = {
  /**
   * Fetches settings based on category and active status
   * @param {Object} params - Parameters for the request
   * @returns {Promise<Array>} A promise that resolves to an array of setting objects
   */
  getSettings: async (params) => {
    const response = await axiosInstance.get("/settings/getall", { params });
    return response.data;
  },

  /**
   * Toggles a setting's active status
   * @param {string} settingId - The ID of the setting to toggle
   * @param {string} employeeType - The employee type ("permanent" or "contract")
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  toggleSetting: async (settingId, employeeType) => {
    const response = await axiosInstance.put(`/settings/update/toggle/${settingId}`, {
      employee_type: employeeType,
    });
    return response.data;
  },

  /**
   * Updates a setting's value
   * @param {string} settingId - The ID of the setting to update
   * @param {string} employeeType - The employee type ("permanent" or "contract")
   * @param {string} value - The new value for the setting
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  updateSettingValue: async (settingId, employeeType, value) => {
    const response = await axiosInstance.put(`/settings/update/value/${settingId}`, {
      employee_type: employeeType,
      value: value,
    });
    return response.data;
  }
};

export default leaveApi;